


































import Vue from 'vue';
import EnemSubscriptionNumberForm from '@/components/forms/EnemSubscriptionNumberForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import BackButton from '@/components/BackButton.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import { EvaluationEnem } from '@/store/modules/admission/state';
import { Toast } from '@/components/ds';

export default Vue.extend({
  components: {
    EnemSubscriptionNumberForm,
    PipelineMenuWrapper,
    BackButton,
    BottomButton,
    Toast,
  },
  data() {
    return {
      enemSubscriptionNumber: this.$store.getters.enem?.subscriptionNumber || '',
      hasError: false,
      error: false,
      loading: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      return !this.hasError && Boolean(this.enemSubscriptionNumber);
    },
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.loading = true;
      const enem: EvaluationEnem = { subscriptionNumber: this.enemSubscriptionNumber };

      await this.$store.dispatch('UPDATE_ENEM', { enem }).catch(error => this.errorHandler(error));

      pipeline.next();
      this.loading = false;
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
        this.loading = false;
      }, 5000);
      throw error;
    },
    inputHandler(value: string, hasError: boolean) {
      this.enemSubscriptionNumber = value;
      this.hasError = hasError;
    },
  },
});
